// frontend/src/components/auth/LoginForm.js
import React, { useState } from 'react';
import { loginUser } from '../../api/auth';
import { useNavigate } from 'react-router-dom';
import { useChat } from '../../context/ChatContext.js';
import axios from '../../api/axiosInstance';
import './LoginRegister.css';
import { debugLog } from '../../utils/logging/debugLog';

export default function LoginForm() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const { updateMemory, updateUser } = useChat();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    debugLog('🟨 handleSubmit triggered');

    try {
      const res = await loginUser(formData);
      debugLog('📥 LoginForm received response:', res);

      // Cookie is the authority now. Hydrate from /auth/me.
      const meRes = await axios.get('/api/auth/me');
      const hydratedUser = meRes.data;

      if (!hydratedUser?.id) {
        throw new Error('Login succeeded but user hydration failed.');
      }

      updateUser(hydratedUser);
      updateMemory('userId', hydratedUser.id);
      updateMemory('userName', hydratedUser.first_name || 'Friend');

      if (hydratedUser.access_level === 'expired') {
        navigate('/welcome', {
          state: {
            expired: true,
            user_id: hydratedUser.id,
            email: hydratedUser.email,
            first_name: hydratedUser.first_name,
          },
        });
      } else {
        navigate('/chat');
      }
    } catch (err) {
      console.error('🚨 Login catch block triggered:', err);
      setMessage(err.message || 'Login failed. Please try again.');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">

        <div className="auth-header">
          <h1>dAIsy</h1>
          <p>Your conversation companion</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Welcome back</h2>

          <input
            name="email"
            type="email"
            placeholder="Email address"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            name="password"
            type="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button className="auth-primary-btn" type="submit">
            Sign In
          </button>

          {message && <p className="auth-error">{message}</p>}
        </form>

        <div className="auth-divider">
          <span>or</span>
        </div>

        <button
          className="auth-google-btn"
          onClick={() =>
            (window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`)
          }
        >
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            alt="Google"
            className="google-icon"
          />
          Continue with Google
        </button>

        <div className="auth-links">
          <p>
            Don’t have an account? <a href="/register">Create one</a>
          </p>
          <p>
            Forgot password? <a href="/reset-password">Reset it</a>
          </p>
        </div>

      </div>
    </div>
  );
}